import * as React from 'react';
import * as ReactTooltip from 'react-tooltip';
import { TooltipContent } from './styles';

const Translate = require('react-redux-i18n').Translate;

const TOOLTIP_DELAY = 500;
const TOOLTIP_OFFSET: Offset = {
	bottom: 10,
	right: 20
};

interface Offset {
	bottom: number;
	right: number;
}

interface TooltipProps {
	id: string;
	text: string;
	isCustom?: boolean;
}

const Tooltip = (props: TooltipProps) => {
	const { id, text, isCustom } = props;

	return (
		<ReactTooltip id={id} place="bottom" effect="solid" delayShow={TOOLTIP_DELAY} offset={TOOLTIP_OFFSET}>
			<TooltipContent>
				{isCustom
					? text
					: <Translate value={text} />
				}
			</TooltipContent>
		</ReactTooltip>
	);
};

export default Tooltip;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Tooltip/index.tsx